module.exports = __webpack_public_path__ + "static/media/user-6.0b6ec0e6.png";